import { useMemo } from 'react'

import isMobileDevice from '../utils/isMobileDevice'

/**
 * Hook that provides click/touch props for mobile-aware interactions.
 * Uses onTouchStart on mobile to avoid double-tap zoom issues.
 *
 * @param {Function|null} onClick - The click handler function
 * @returns {{ props: Object, isMobile: boolean }}
 */
function useMobileClick(onClick) {
  const isMobile = useMemo(() => isMobileDevice(), [])

  const props = useMemo(() => {
    if (!onClick) return {}

    if (!isMobile) return { onClick }

    return {
      onTouchStart: (e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick(e)
      },
    }
  }, [onClick, isMobile])

  return { props, isMobile }
}

export default useMobileClick
